import React from "react";
import HeadshotComponent from "../../conversations/components/headshot";
import RepliesStates from "../types/replies_states";
import moment from "moment";
import createSlice from "../utils/create_slice";

const Subthread = ({ subthreads, repliesState, incrementChildRepliesShowCount }) => {

  const createSubthread = () => (
    subthreads && (
      subthreads.slice(...createSlice(RepliesStates, repliesState, incrementChildRepliesShowCount)).map( thread => {
        const { creator } = thread;
        return (
          <div className="subthread message" key={ thread.id } >
          <HeadshotComponent user={ creator } />
            <div className="message-right">
              <p className="t5 w3 message-name">
                <a className="text-black" key={ creator.id } href={ creator.profileLink }>{ creator.displayName }</a>

                <small className="t6 dark-gray text-default message-time pull-right" title={ thread.createdAt }>
                  { moment(thread.createdAt).fromNow() }
                </small>
              </p>

              <small className="t6 dark-gray line-clamp-2" title={ creator.companyTitle }>{ creator.companyTitle.replace(' at ', ', ') }</small>

              <div className="message-main">
                <div className="message-header mb-5"></div>

                <div className="t5 content"
                  dangerouslySetInnerHTML={{ __html: thread.body }}>
                </div>
              </div>
            </div>
          </div>
        )
      })
    )
  )

  return createSubthread().reverse();
};

export default Subthread;
